module.exports = __webpack_public_path__ + "img/img_galaxia.cffdd42c.png";